import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../Apis/apiCall";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import { usePermissions } from "../context/PermissionContext";
import { Icon } from "@iconify/react/dist/iconify.js";
import Breadcrumb from "../components/Breadcrumb";
import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";

const AddCountryLayer = () => {
  const [countryName, setCountryName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [currencyCode, setCurrencyCode] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [timezone, setTimezone] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value.toUpperCase());
  };

  const handleCurrencyCodeChange = (e) => {
    setCurrencyCode(e.target.value.toUpperCase());
  };

  const handleCurrencySymbolChange = (e) => {
    setCurrencySymbol(e.target.value);
  };

  const validateFields = () => {
    if (!countryName.trim()) {
      handleCustomResponse("error", "Country name is required.");
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return countryName.trim() !== "";
  };

  const handleAddCountry = async (e) => {
    e.preventDefault();

    if (!validateFields()) {
      return;
    }

    try {
      setLoading(true);

      const payload = {
        country_name: countryName,
        country_code: countryCode || null,
        currency_code: currencyCode || null,
        currency_symbol: currencySymbol || null,
        timezone: timezone || null,
      };

      const response = await apiCall(
        "post",
        "/create-country",
        payload,
        navigate
      );
      if (response?.data?.success) {
        const handleRes = response.data;
        handleApiResponse(handleRes, "success", "POST");
        
        // Navigate back after successful submission
        setTimeout(() => {
          navigate("/all-countries");
        }, 1000);
      } else {
        handleCustomResponse("error", "Failed to add country.");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "POST");
    } finally {
      setLoading(false);
    }
  };

  if (!hasPermission("insert_countries")) {
    return (
      <div className="p-4">
        <div className="alert alert-danger">
          You do not have permission to add countries.
        </div>
      </div>
    );
  }

  return (
    <>
      <Breadcrumb title="Add Country" />

      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={handleAddCountry} autoComplete="off">
            <div className="row g-20">
              <div className="col-md-6 mb-20">
                <label htmlFor="countryName" className="form-label">
                  Country Name *
                </label>
                <input
                  id="countryName"
                  type="text"
                  className="form-control radius-8"
                  value={countryName}
                  onChange={(e) => setCountryName(e.target.value)}
                  placeholder="Enter country name"
                  disabled={loading}
                />
              </div>

              <div className="col-md-6 mb-20">
                <label htmlFor="countryCode" className="form-label">
                  ISO Country Code
                </label>
                <input
                  id="countryCode"
                  type="text"
                  className="form-control radius-8"
                  value={countryCode}
                  onChange={handleCountryCodeChange}
                  placeholder="Enter ISO country code (e.g., PK)"
                  maxLength="2"
                  style={{ textTransform: "uppercase" }}
                  disabled={loading}
                />
              </div>

              <div className="col-md-6 mb-20">
                <label htmlFor="currencyCode" className="form-label">
                  Currency Code
                </label>
                <input
                  id="currencyCode"
                  type="text"
                  className="form-control radius-8"
                  value={currencyCode}
                  onChange={handleCurrencyCodeChange}
                  placeholder="Enter currency code (e.g., PKR)"
                  maxLength="3"
                  style={{ textTransform: "uppercase" }}
                  disabled={loading}
                />
              </div>

              <div className="col-md-6 mb-20">
                <label htmlFor="currencySymbol" className="form-label">
                  Currency Symbol
                </label>
                <input
                  id="currencySymbol"
                  type="text"
                  className="form-control radius-8"
                  value={currencySymbol}
                  onChange={handleCurrencySymbolChange}
                  placeholder="Enter currency symbol (e.g., ₨)"
                  maxLength="5"
                  disabled={loading}
                />
              </div>

              <div className="col-md-6 mb-20">
                <label htmlFor="timezone" className="form-label">
                  Timezone
                </label>
                <input
                  id="timezone"
                  type="text"
                  className="form-control radius-8"
                  value={timezone}
                  onChange={(e) => setTimezone(e.target.value)}
                  placeholder="Enter timezone (e.g., Asia/Karachi)"
                  disabled={loading}
                />
              </div>
            </div>

            <div className="d-flex justify-content-center gap-3">
              <CancelButtonForm />
              <UpdateButtonForm 
                // disabled={loading || !isFormValid()}
                text={loading ? "Please wait..." : "Add Country"}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCountryLayer;